var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcConfirm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .icon-confirm{\n    fill:none;\n  }\n  .icon-confirm .b{\n    fill:#F3F3F3;\n  }\n  .icon-confirm .c{\n    stroke-linejoin:round;\n    stroke:#646464;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-confirm"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-519 -211)translate(519 211)",
    className: "undefined"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    className: "undefined"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "12 20.9 16.6 25.4 28 14",
    className: "c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConfirm);
export default __webpack_public_path__ + "static/media/icConfirm.49b73136025b46fbf5c2dda69a01bda4.svg";
export { ForwardRef as ReactComponent };